import { FC } from "react";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import  StepperWeb  from "./layout/Stepper.web";
import StepperMob from "./layout/Stepper.mob";
import { Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { StepperProps } from "./constants";

const StepperComponent = withConditionalComponent(StepperWeb,StepperMob);

const Stepper: FC<StepperProps> = (props) => {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <StepperComponent props={props} trigger={isLargeScreen}/>
};

export default Stepper;